import { css, customElement } from "lit";
import CDSMultiSelect from "@carbon/web-components/es/components/multi-select/multi-select";

class CogMultiSelect extends CDSMultiSelect {
    static styles = css`
        ${CDSMultiSelect.styles}
        .cds--list-box {
            block-size: auto;
            max-block-size: none;
            display: block;
            width: 100%;
            padding: 0 var(--input--padding-block);
            border: var(--input--border-width) solid var(--input--border-color);
            border-radius: var(--input--border-radius);
            background: var(--input--background-color);
            box-shadow: none;
            color: var(--input--color);
            font-family: inherit;
            line-height: inherit;
            font-size: 1rem;
            padding-right: 2em;
            appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.382823 0.817787C-0.0565166 1.25713 -0.0565165 1.96944 0.382823 2.40878L5.15579 7.18175C5.59513 7.62109 6.30744 7.62109 6.74678 7.18175C7.18612 6.74241 7.18612 6.0301 6.74678 5.59076L1.97381 0.817787C1.53447 0.378447 0.822163 0.378447 0.382823 0.817787Z' fill='black'/%3E%3Cpath d='M11.617 0.817819C11.1777 0.378479 10.4654 0.378479 10.026 0.817819L5.25307 5.59079C4.81373 6.03013 4.81373 6.74244 5.25307 7.18178C5.69241 7.62112 6.40472 7.62112 6.84406 7.18178L11.617 2.40881C12.0564 1.96947 12.0564 1.25716 11.617 0.817819Z' fill='black'/%3E%3C/svg%3E%0A");
            background-position: right var(--input--padding-block) top 50%;
            background-repeat: no-repeat;
            background-size: 0.8em auto;
            cursor: pointer;
            box-sizing: border-box;
        }
        .cds--list-box__field {
            padding-top: calc(var(--input--padding-block) + 1px);
            padding-bottom: calc(var(--input--padding-block) - 1px);
            padding-inline: 0;
            min-height: 48px;
        }
        .cds--list-box__menu-icon {
            display: none;
        }
        .cds--multi-select .cds--tag {
            margin: 0 8px 0 0;
        }
        .cds--list-box__field:has(.cds--list-box__menu-icon)
            .cds--list-box__selection::after {
            content: none;
        }
        .cds--list-box__menu {
            box-shadow: none;
            border: 1px solid var(--color--black);
        }
        .cds--list-box__menu:focus {
            outline: none;
        }
        label.cds--label[hidden] {
            position: absolute;
            font-size: 0;
            opacity: 0;
            display: none;
        }
        .cds--multi-select:not(.cds--list-box--expanded) .cds--list-box__menu {
            visibility: visible;
        }
    `;
}
customElements.define("cog-multi-select", CogMultiSelect);
